let routes = [
  {
    path: "/",
    name: "Layout",
    redirect: "/Home",
    keywords: "",
    description: "",
    component: () => import("@/Layout/Layout.vue"),
    meta: {
      title: "layout",
      icon: "",
      hidden: false,
      fatherPath: "/",
      keywords: "",
      description: "",
    },

    children: [
      {
        path: "/Home",
        name: "Home",
        component: () => import("@/views/Home/Home.vue"),

        meta: {
          title: "首页",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "binar Handling",
          description: "binar Handling",
        },
      },
      {
        path: "/ProductList",
        name: "ProductList",
        component: () => import("@/views/ProductList/ProductList.vue"),

        meta: {
          title: "产品中心",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/ProductDetail",
        name: "ProductDetail",
        component: () => import("@/views/ProductList/ProductDetail.vue"),

        meta: {
          title: "产品详情",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/ProductDetailDetail",
        name: "ApplicationDetail",
        component: () => import("@/views/ProductList/ProductDetailDetail.vue"),

        meta: {
          title: "产品信息",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/SolutionPage",
        name: "SolutionPage",
        component: () => import("@/views/SolutionPage/SolutionPage.vue"),

        meta: {
          title: "解决方案",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/TechnicalSupport",
        name: "TechnicalSupport",
        component: () =>
          import("@/views/TechnicalSupport/TechnicalSupport.vue"),

        meta: {
          title: "服务支持",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/Jobs",
        name: "Jobs",
        component: () => import("@/views/Jobs/Jobs.vue"),

        meta: {
          title: "人才招聘",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/News",
        name: "News",
        component: () => import("@/views/News/News.vue"),

        meta: {
          title: "新闻中心",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/ContactUs",
        name: "ContactUs",
        component: () => import("@/views/ContactUs/ContactUs.vue"),

        meta: {
          title: "联系我们",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/About",
        name: "About",
        component: () => import("@/views/About/About.vue"),

        meta: {
          title: "关于Binar Handling",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/DownloadFile",
        name: "DownloadFile",
        component: () => import("@/views/DownloadFile/DownloadFile.vue"),

        meta: {
          title: "资料下载",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/DownloadVideo",
        name: "DownloadVideo",
        component: () => import("@/views/DownloadVideo/DownloadVideo.vue"),

        meta: {
          title: "视频下载",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/Search",
        name: "Search",
        component: () => import("@/views/Search/Search.vue"),

        meta: {
          title: "搜索",
          image: "",
          hidden: false,

          fatherPath: "/",
          keywords: "",
          description: "",
        },
      },
      {
        path: "/PreviewPdf",
        name: "PreviewPdf",
        component: () => import("@/views/PreviewPdf/PreviewPdf.vue"),
        meta: {
          title: "pdf预览",
          icon: "",
          fatherPath: "/",
        },
      },
    ],
  },
  //   {
  //     path: "/PreviewPdf",
  //     name: "PreviewPdf",
  //     component: () => import("@/views/PreviewPdf/PreviewPdf.vue"),
  //     meta: {
  //         title: "pdf预览",
  //         icon: "",
  //         fatherPath: "",
  //     },
  // },
];

routes[0].children = routes[0].children.map((item) => {
  item.path = "/:lang/" + item.path;
  return item;
});

// console.log("routes.js", routes);

export default routes;
